module.exports = "/_next/static/images/x-gray600-29c4640745ee359b3e6f69815d8e856e.svg";